import React from "react";

const tabs = [
  { label: "Game record" },
  { label: "Cash-In / Cash-Out" },
  { label: "Facilities" },
];

interface CustomerTabsProps {
  activeTab: number;
  onTabChange: (tabIndex: number) => void;
}

export const CustomerTabs: React.FC<CustomerTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="flex flex-nowrap overflow-x-auto bg-slate-900 scrollbar-hide w-full">
      {tabs.map((tab, idx) => (
        <button
          key={tab.label}
          onClick={() => onTabChange(idx)}
          className={`px-3 md:px-6 py-3 md:py-4 text-xs md:text-sm font-medium focus:outline-none transition-all duration-200 whitespace-nowrap flex-shrink-0 relative
            ${
              activeTab === idx
                ? "bg-sky-800 text-white z-10"
                : "bg-white text-slate-700 hover:bg-slate-50 hover:text-slate-900"
            }`}
          style={{ minWidth: "120px" }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};
